import Modal from '../../../../components/Modal'
import React from 'react'
import { IconCheckMark, IconError, IconStopHand, IconSuccess } from '../../../../svg'

export const DeleteProjectModal = ({
    modal: { isOpen, name, data, isSuccess, isError },
    t,
    deleteProjectAgreement,
    checkboxClick,
    closeModal,
    deleteProject,
}) => {
    return (
        <Modal
            settings={{ overlayClose: true }}
            data={{ open: isOpen && name === 'delete_project', maxWidth: 640 }}
            events={{ onCloseModal: closeModal }}
        >
            {data && (
                <div className="modal-variant--1">
                    {!isSuccess && !isError ? (
                        <div className="main">
                            <div className="title">{t('_pages._my_projects.wait')}</div>
                            <div className="icon">
                                <IconStopHand />
                            </div>
                            <div className="text">
                                <p>
                                    {t('_pages._my_projects.text_3')} “{data.name}”.
                                </p>
                                <p>
                                    {t('_pages._my_projects.text_4_1')}{' '}
                                    <span>{t('_pages._my_projects.text_4_2')}.</span>
                                </p>
                            </div>
                            <div className="check-agree">
                                <div
                                    className={`checkbox-box ${deleteProjectAgreement ? 'is-checked' : ''}`}
                                    onClick={checkboxClick('deleteProjectAgreement', false)}
                                >
                                    <IconCheckMark />
                                </div>
                                <p className="us-n" onClick={checkboxClick('deleteProjectAgreement', false)}>
                                    {t('_pages._my_projects.text_5')}
                                </p>
                            </div>
                            <div className="buttons">
                                <button
                                    className="button"
                                    disabled={!deleteProjectAgreement}
                                    data-size="md"
                                    data-variant="primary-danger"
                                    onClick={deleteProject(data)}
                                >
                                    {t('_common.delete')}
                                </button>
                                <button className="button" data-size="md" data-variant="secondary" onClick={closeModal}>
                                    {t('Cancel')}
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className={`result result-${isSuccess ? 'success' : 'error'}`}>
                            <div className="icon">{isSuccess ? <IconSuccess /> : <IconError />}</div>
                            <div className="title">
                                {isSuccess
                                    ? t('_pages._my_projects.success_delete_title')
                                    : t('_pages._my_projects.failed_delete_title')}
                            </div>
                            <div className="text">
                                {isSuccess ? (
                                    <>{t('_pages._my_projects.success_delete_text')}</>
                                ) : (
                                    <>{t('_pages._my_projects.failed_delete_text')}</>
                                )}
                            </div>
                            <div className="buttons">
                                <button
                                    className="button"
                                    data-size="md"
                                    data-variant={isSuccess ? 'primary' : 'secondary'}
                                    onClick={closeModal}
                                >
                                    {isSuccess ? t('OK') : t('Close')}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </Modal>
    )
}
